import postAPI from './postAPI.js'

export default async function postCreateTaskFlow(taskFlowData) {
    const data = await postAPI('admin/taskflows/create', taskFlowData);
    return data;
}
